export const NotificationType = Object.freeze({
    success: 'success',
    error: 'error',
    warn: 'warn',
    info: 'info'
})
